import { Component, OnInit, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'delete-tenant-modal',
  templateUrl: './delete-tenant-modal.component.html',
  imports: [FaIconComponent]
})
export class DeleteTenantModalComponent implements OnInit {
  bsModalRef = inject(BsModalRef);

  mailto: string;
  subject: string;

  ngOnInit() {
    setTimeout(() => {
      this.subject = $localize `:@@shared.components.delete_tenant_modal.subject:Delete my tenant ${this.bsModalRef.content?.model.id}:tenantId: ${this.bsModalRef.content?.model.name}:tenantName: with all its uploaded documents and configurations`;
      this.mailto = 'mailto:support@parashift.io'
      + '?subject=' + this.subject
      + '&body=Tenant ID: ' + this.bsModalRef.content.model.id
      + '%0D%0A'
      + 'Tenant Name: ' + this.bsModalRef.content.model.name;
    });
  }

  close() {
    this.bsModalRef.hide();
  }
}
